import { useContext } from 'react';
import { WorkbookDataContext } from '../Context';

export const useWorkbookData = () => {
  const data = useContext(WorkbookDataContext);

  return data;
};

export default useWorkbookData;